import { semesters } from "keys";
import { semesterAndYearOptions } from "keys/years";
import moment from "moment";

const getSemester = (nDate) => {
    const date = new Date(nDate)
    const formattedDate = moment(date).format('MM-DD');

    for (const [semester, value] of Object.entries(semesters)) {
        for (const range of value.range) {
            const startDate = moment(range.start, 'MM-DD');
            const endDate = moment(range.end, 'MM-DD');

            if (moment(formattedDate, 'MM-DD').isBetween(startDate, endDate, null, '[]')) {
                return value.id;
            }
        }
    }

    return '1';
}

const getCurrentSemester = () => {
    return getSemester(new Date())
}

const getCurrentSemesterAndYear = () => {
    const semester = getCurrentSemester()
    const year = new Date().getFullYear()
    const currentSemester = semesters.find(sem => sem.id == semester)
    const currentYear = semesterAndYearOptions.find(ye => ye.id == (semester > 1 ? year : year + 1))

    return { semester: currentSemester, school_year: currentYear }
}

const getCurrentYearOpt = () => {
    const semester = getCurrentSemester()
    const year = new Date().getFullYear()
    const currentYear = semesterAndYearOptions.find(ye => ye.id == (semester > 1 ? year : year + 1))

    return currentYear
}


const getPrevSemesterAndYear = () => {
    const semester = getCurrentSemester()
    const prevSemester = getPrevSemester(semester)
    const year = new Date().getFullYear()
    const currentSemester = semesters.find(sem => sem.id == prevSemester)
    const currentYear = semesterAndYearOptions.find(ye => ye.id == (prevSemester > 1 ? year : year + 1))

    return { semester: currentSemester, year: currentYear }
}

const getPrevSemester = (se) => {
    let semester = Number(se)
    return semester == 1 ? 3 : semester - 1
}

const getCurrentSchoolYear = () => {
    const year = new Date().getFullYear()
    const semester = getCurrentSemester()

    if (semester?.toString() == '1')
        return year + 1
    else return year
}

const getSemesterDates = () => {
    const semester = getSemester(new Date())
    return semesters[semester - 1]
}

const checkAndRefreshDaily = () => {
    // מחלץ את התאריך של היום כמחרוזת (ללא שעות), למשל: "Sun Oct 18 2026"
    const today = new Date().toDateString();
    const lastRefreshDate = localStorage.getItem('lastRefreshDate');

    if (lastRefreshDate !== today) {
        // מעדכנים את תאריך הרענון להיום
        localStorage.setItem('lastRefreshDate', today);

        // מבצעים רענון מלא של העמוד
        window.location.reload();

        return true; // מחזיר אמת כדי לסמן שהיה רענון
    }

    return false; // לא היה צורך ברענון
};

export { checkAndRefreshDaily, getCurrentYearOpt, getPrevSemesterAndYear, getPrevSemester, getCurrentSemesterAndYear, getCurrentSchoolYear, getSemesterDates, getCurrentSemester, getSemester }
